import { createI18n } from 'vue-i18n'
import en from './en.json'
import sv from './sv.json'
import no from './no.json'
import dk from './dk.json'
import { useStore } from 'vuex'
import { onMounted } from 'vue'
const store = useStore()

const fetchLanguage = async () => {
  try {
    await store.dispatch('account/getMe')
  } catch (error) {
    console.error('Error fetching language:', error)
    // Set the default language to English in case of an error
    store.commit('account/setLanguage', 'sv')
  }
}

onMounted(async () => {
  fetchLanguage()
})

if (!window.apiConfig) {
  const timestamp = new Date().getTime() // Generates a unique timestamp
  const response = await fetch(`${process.env.BASE_URL}config.json?v=${timestamp}`)
  const config = await response.json()
  // console.log(config)
  window.apiConfig = config
}

const i18n = createI18n({
  locale: window.apiConfig.DEFAULTLANGUAGE,
  messages: {
    sv: sv,
    en: en,
    no: no,
    dk: dk
  }
})

export default i18n
